import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import BlogPage from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/mentions-legales" element={<Legal type="mentions" />} />
          <Route path="/politique-confidentialite" element={<Legal type="confidentialite" />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
